var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingEmoji1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.8069 38.8069 50 25 50C11.1944 50 0 38.8069 0 25C0 11.1944 11.1944 0 25 0C38.8069 0 50 11.1944 50 25Z",
    fill: "#F8CD5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9722 24.9996C17.8899 24.9996 19.4444 22.8232 19.4444 20.1385C19.4444 17.4537 17.8899 15.2773 15.9722 15.2773C14.0546 15.2773 12.5 17.4537 12.5 20.1385C12.5 22.8232 14.0546 24.9996 15.9722 24.9996Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0279 24.9996C35.9455 24.9996 37.5001 22.8232 37.5001 20.1385C37.5001 17.4537 35.9455 15.2773 34.0279 15.2773C32.1102 15.2773 30.5557 17.4537 30.5557 20.1385C30.5557 22.8232 32.1102 24.9996 34.0279 24.9996Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0348 38.7098C12.2821 38.9334 12.6515 38.9473 12.9168 38.7501C12.9709 38.7098 18.364 34.7223 25.0001 34.7223C31.6196 34.7223 37.0307 38.7098 37.0834 38.7501C37.3487 38.9473 37.7182 38.9307 37.9654 38.7098C38.2112 38.4876 38.2668 38.1209 38.0959 37.8376C37.9168 37.5404 33.6279 30.5557 25.0001 30.5557C16.3723 30.5557 12.0821 37.539 11.9043 37.8376C11.7334 38.1223 11.7876 38.4876 12.0348 38.7098Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingEmoji1);
export default __webpack_public_path__ + "static/media/rating_emoji_1.433850e26468d32d1f8236a25fca2267.svg";
export { ForwardRef as ReactComponent };